import { AllergicRhinitisDocTypes } from "../../../components/patient/clinical-services/service-steps/documentation/data";

const initialState = {
  minorAilmentsResponse: [], // moved from patient reducer
  medicationReviewResponse: [], // moved from patient reducer
  notesResponse: [], // for notes data
  medicalSummaryFilters: null, //save current filters
  medicalSummaryRecord: null,
  selectedRowId: null, // track selected row ID for persistence
  loading: false,
  error: null,
};

const medicalSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELECTED_MEDICAL_SUMMARY":
      return {
        ...state,
        medicalSummaryRecord: action.payload || {},
        loading: false,
        error: null,
      };
    case "SET_SELECTED_ROW_ID":
      return {
        ...state,
        selectedRowId: action.payload,
      };
    case "GET_MINOR_AILMENTS_SUCCESS":
      return {
        ...state,
        minorAilmentsResponse: action.payload.minorAilments || [],
        loading: false,
        error: null,
      };
    case "GET_MINOR_AILMENTS_FAILURE":
      return {
        ...state,
        minorAilmentsResponse: [],
        loading: false,
        error: action.payload,
      };
    case "GET_MEDICATION_REVIEW_SUCCESS":
      return {
        ...state,
        medicationReviewResponse: action.payload.medicationReviews || [],
        loading: false,
        error: null,
      };
    case "GET_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        medicationReviewResponse: [],
        loading: false,
        error: action.payload,
      };
    case "GET_NOTES_SUCCESS":
      return {
        ...state,
        notesResponse: action.payload.notePads || [],
        loading: false,
        error: null,
      };
    case "GET_NOTES_FAILURE":
      return {
        ...state,
        notesResponse: [],
        loading: false,
        error: action.payload,
      };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default medicalSummaryReducer;